/**
 * @generated SignedSource<<21d1fb897997dd4a47cdad601d8c112a>>
 * @relayHash a1a75dc4f6dc69d69775faebff7344c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b8092d067ac5abadad6a058dc2de81c9d25eef7713acd962c922ec7fdac81b79

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { WorkItemEntrypointUiQuery } from './WorkItemEntrypointUiQuery.graphql';

import isJscInlineEditFastFollowsEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-inline-edit-fast-follows-enabled.relayprovider';
import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';
import isJiraAiAgentAvatarSingleUserPickerEnabled_provider from '@atlassian/jira-relay-provider/src/jira-ai-agent-avatar-single-user-picker.relayprovider';
import shouldShowHumanSupervisor_provider from '@atlassian/jira-relay-provider/src/jira-ai-show-human-supervisor-avatar.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import originalEstimateEditableFixFlag_provider from '@atlassian/jira-relay-provider/src/jira-original-estimate-editable-fix.relayprovider';
import fixDisabledVotingOption_provider from '@atlassian/jira-relay-provider/src/jracloud-81233-fix-disabled-voting-option.relayprovider';
import isIssueViewFieldConfigEditEnabled_provider from '@atlassian/jira-relay-provider/src/relay-migration-issue-fields-custom-field-config.relayprovider';
import isRemoveIssueTypes_provider from '@atlassian/jira-relay-provider/src/remove-issue-types-dfo.relayprovider';
import simplifiedTimeTracking_provider from '@atlassian/jira-relay-provider/src/simplified-time-tracking.relayprovider';

const node: PreloadableConcreteRequest<WorkItemEntrypointUiQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b8092d067ac5abadad6a058dc2de81c9d25eef7713acd962c922ec7fdac81b79",
    "metadata": {},
    "name": "WorkItemEntrypointUiQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjracloud81233fixdisabledvotingoptionrelayprovider": fixDisabledVotingOption_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcremoveissuetypesdforelayprovider": isRemoveIssueTypes_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider": isJiraAiAgentAvatarSingleUserPickerEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcrelaymigrationissuefieldscustomfieldconfigrelayprovider": isIssueViewFieldConfigEditEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinlineeditfastfollowsenabledrelayprovider": isJscInlineEditFastFollowsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsimplifiedtimetrackingrelayprovider": simplifiedTimeTracking_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": shouldShowHumanSupervisor_provider
    }
  }
};

export default node;
